export const dropdownOptions = [
  { label: 'Go with merchant recommendation', value: 'recommendation' },
  { label: 'Refund this item', value: 'refund' },
  { label: 'Contact me', value: 'contact_me' },
  { label: 'Cancel the entire order', value: 'cancel_order' },
];

const formDefaultValues = {
  instruction: '',
  if_unavailable: dropdownOptions[0],
};

export default formDefaultValues;
